import { api } from './api'

export const Cart = {
    async add(product_id, quantity) {
        const qty = document.getElementById('quantity')

        if (qty) {
            quantity = qty.value
        }
        const response = await api.post(
            'checkout/cart/add',
            `product_id=${product_id}&quantity=${quantity}`
        )

        await this.updateMiniCartInfo()
        this.notify('cart-info', response)
    },
    async update(key, quantity) {
        const response = await api.post(
            'checkout/cart/edit',
            `key=${key}&quantity=${quantity}`
        )
        this.notify('cart-info', response)
    },
    async remove(key, open = true) {
       const response = await api.post(
            'checkout/cart/remove',
            `key=${key}`
        ).then()

        await this.updateMiniCartInfo()
        await this.updateCheckoutCartInfo()

        if (response.cartItems === 0) {
            location.href = '/index.php?route=checkout/cart';
        }
        if (open) {
            setTimeout(() => {
                window.dispatchEvent(new CustomEvent('open-cart'))
            }, 100)
        }
    },
    async coupon(c) {
        const response = await api.post(
            'extension/total/coupon/coupon',
            `coupon=${c}`
        )
        if (response.error) {
            window.dispatchEvent(new CustomEvent('modal', {
                detail: {
                    message: `<p class="text-red-500 text-base">${response.error}</p>`,
                    title: '',
                    size: 'sm:max-w-md'
                }
            }));
            return;
        }

        await this.updateMiniCartInfo()
        await this.updateCheckoutCartInfo()

        window.dispatchEvent(new CustomEvent('modal', {
            detail: {
                message: `<p class="text-green-500 text-base">${response.message}</p>`,
                title: '',
                size: 'sm:max-w-md'
            }
        }));
    },
    async shipping(c) {
        const response = await api.post(
            'quickcheckout/shipping_method/updateshipping',
            `code=${c}`
        )
        await this.updateMiniCartInfo()
        await this.updateCheckoutCartInfo()
    },
    notify(eventName, response) {
        window.dispatchEvent(new CustomEvent(eventName, {
            detail: {
                message: response.success,
                image: response.image,
                cartItems: typeof response.cartItems !== 'undefined' ? response.cartItems : false
            }
        }))
    },
    async updateMiniCartInfo() {
        const cartInfo = (await api.get('common/cart/info')).text()
        cartInfo.then((data) => {
            document.getElementById('cart').innerHTML = data
        })
    },
    async updateCheckoutCartInfo() {
        const checkoutCart = (await api.get('quickcheckout/cart')).text()
        checkoutCart.then((data) => {
            document.getElementById('cart_view').innerHTML = data
        })
    }
}